module.exports = __webpack_public_path__ + "img/vacation.8aaabc00.png";